var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHouseIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#houseIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#242E30",
  d: "M18.805 10.087c-.197-.207-4.77-5.217-7.657-7.153a2.19 2.19 0 0 0-2.242.011C5.964 4.87 1.392 9.88 1.25 10.087l1.214 1.094S3 10.612 3.766 9.803v7.569h12.578V9.814c.765.81 1.28 1.367 1.301 1.378zm-7.711 5.655v-2.46a1.094 1.094 0 1 0-2.188 0v2.46H5.352v-7.59a35 35 0 0 1 4.375-3.829.54.54 0 0 1 .48 0 35.4 35.4 0 0 1 4.376 3.84v7.59z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "houseIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1.25 1.25h17.5v17.5H1.25z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHouseIcon);
export default ForwardRef;